import React from 'react';

export const Header = () => {
  return (
    <div className="absolute w-full left-[23px] top-5 sm:left-4 sm:top-4">
      <img className="h-10 sm:h-9" src="/images/leftBar/logo.png" />
    </div>
  );
};
